export default "__VITE_ASSET__5d2759ab__"